import { Label, UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { Underground } from '../Underground';
import { NoImage } from '../NoImage';
import { TRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { trackRecentlyViewedItemClick } from './tracking';

import * as styles from './styles.css';

export interface IRecentlyViewedItemProps {
  offer: TRecentlyViewedOffer;
  position: number;
  favoriteButton: React.ReactNode;
}

export const RecentlyViewedItem: React.FC<IRecentlyViewedItemProps> = ({ offer, position, favoriteButton }) => {
  const { formattedPrice, title, href, photoUrl, address, discount, underground } = offer;

  const price = discount ? discount.newPrice : formattedPrice;

  const onClickHandler = React.useCallback(
    () => trackRecentlyViewedItemClick({ offer, position }),
    [trackRecentlyViewedItemClick, offer, position],
  );

  return (
    <a onClick={onClickHandler} href={href} target="_blank" className={styles['container']} rel="noreferrer">
      <span className={styles['favorite']}>{favoriteButton}</span>
      {photoUrl ? <img src={photoUrl} className={styles['image']} /> : <NoImage />}
      <div className={styles['content']}>
        <div className={styles['ellipsis']}>
          <UIHeading5>{price}</UIHeading5>
        </div>
        {discount && (
          <div className={styles['discount']}>
            <span className={styles['price-discount']}>
              <Label background="accent-positive-primary" color="text-inverted-default">
                {discount.percent}
              </Label>
              <span className={styles['old-price']}>{discount.oldPrice}</span>
            </span>
          </div>
        )}
        <div className={styles['ellipsis']}>
          <UIText2>{title}</UIText2>
        </div>
        {underground && underground.name && <Underground underground={underground} />}
        {address && (
          <div className={styles['ellipsis']}>
            <UIText2 color="text-secondary-default">{address}</UIText2>
          </div>
        )}
      </div>
    </a>
  );
};
